<template>
    <v-col cols="12">
        <v-row class="my-2 my-sm-1">
            <agrolink-order-list
                v-if="agrolinkOrderProducts.length > 0"
                :orders="agrolinkOrderProducts"
            ></agrolink-order-list>
        </v-row>
        <v-divider class="my-1"></v-divider>
        <template
            v-for="(order, idx) in orderProducts"
        >
            <v-row class="my-3 my-sm-1">
                <order-item
                    :index="idx"
                    :order="order"
                ></order-item>
            </v-row>
            <v-divider class="py-1"></v-divider>
        </template>

    </v-col>
</template>

<script>
import AgrolinkOrderList from "./AgrolinkOrders/AgrolinkOrderList";
import OrderItem from "./Orders/OrderItem"

import OrderDataProvider from "../../../app-front/mixins/OrderDataProvider";

export default {
    name: "OrderList",
    components: {
        AgrolinkOrderList,
        OrderItem
    },
    mixins: [
        OrderDataProvider
    ],
    data() {
        return {
            isLoading: true
        }
    },
    computed: {
        initialProducts() {
            return !this.$route.query.sellerID ? this.orderInitialProducts : this.orderInitialProducts.filter(order => {
                return order.seller.id === parseInt(this.$route.query.sellerID);
            });
        },
        orderProducts() {
            const orders = [];
            this.initialProducts.forEach((item) => {
                const products = item.data.filter(product => product.selfShipment !== true)
                if (products.length > 0) {
                    orders.push({
                        data: products,
                        policies: item.policies,
                        seller: item.seller,
                    })
                }
            })
            return orders
        },
        agrolinkOrderProducts() {
            const orders = [];
            this.initialProducts.forEach((item) => {
                const products = item.data.filter(product => product.selfShipment === true)
                if (products.length > 0) {
                    orders.push({
                        data: products,
                        policies: item.policies,
                        seller: item.seller,
                    })
                }
            })
            return orders
        },
    }
}
</script>

<style scoped>

</style>
